import {CommandBase} from "./commandBase";
import {RemoteConstantsModel} from "../models/remoteConstants.model";
import {removeEdgeRoute} from "../utils/techTree.utils";

export class AddTechDependencyCommand extends CommandBase {
    targetNode: string;
    parentNode: string;

    constructor(targetNode: string, parentNode: string) {
        super();
        this.targetNode = targetNode;
        this.parentNode = parentNode;
    }

    execute(data: RemoteConstantsModel): boolean {
        const index = data.techTree.findIndex(t => t.id === this.parentNode);
        if (index <= 0) {
            return false;
        }

        const alreadyChild = data.techTree[index].children.includes(this.targetNode);
        if (alreadyChild) {
            data.techTree[index].children = data.techTree[index].children.filter(c => c !== this.targetNode);
            // The edge is gone, so its authored bends go with it — otherwise
            // re-adding the dependency would resurrect a route the designer
            // can no longer see.
            removeEdgeRoute(data.techTree[index], this.targetNode);
        } else {
            data.techTree[index].children.push(this.targetNode);
        }

        return true;
    }
}